export default __webpack_public_path__ + "static/media/Group 396.b86b1ff6.svg";